import React from 'react';
import './styles.scss';

/**
 * Credentials Component
 *
 * Displays training, certifications, and professional background.
 */

export const Credentials = () => {
  return (
    <div className="credentials-section">
      <h3>Credentials & Training</h3>

      <div className="credentials-list">
        <div className="credential-item">
          <p>
            <strong>Advanced training across Tibetan Buddhist contemplative traditions</strong>, supported by long‑term retreat and mentorship.
          </p>
        </div>

        <div className="credential-item">
          <p>
            <strong>Certified Mindfulness Meditation Teacher through Dharma Moon / Tibet House</strong> (100 hours).
          </p>
        </div>

        <div className="credential-item">
          <p>
            <strong>Five years of apprenticeship‑style teacher development</strong> with thousands of supervised hours.
          </p>
        </div>

        <div className="credential-item">
          <p>
            <strong>Trusted workplace mentor and mindfulness guide</strong>, supporting teams at Warner Brothers Discovery and FARM Advertising Agency.
          </p>
        </div>

        <div className="credential-item">
          <p>
            <strong>Recognized for a warm, grounded teaching style</strong> and practical tools that help people feel more capable and connected.
          </p>
        </div>
      </div>
    </div>
  );
};
